import { formatPrice } from 'src/services/utils';

const ProductTable = ({ items }) => (
  <div className="col-12 table-responsive">
    <table className="table table-striped table__td">
      <thead>
        <tr>
          <th scope="col">SKU</th>
          <th scope="col">Produto</th>
          <th scope="col" className="txt-center">
            Quantidade
          </th>
          <th scope="col" className="txt-center">
            Valor uni.
          </th>
          <th scope="col" className="txt-center">
            Desconto Total
          </th>
          <th scope="col" className="txt-center">
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map(item => (
          <tr key={item.uuid}>
            <td>{item.sku}</td>
            <td
              className={
                item.quantity > 0 ? '' : 'text-decoration-line-through'
              }
            >
              {item.description}
            </td>
            <td className="txt-center">
              {item.quantity > 0 ? item.quantity : 'Removido'}
            </td>
            <td className="txt-center">{formatPrice(item.unitPrice)}</td>
            <td className="txt-center">{formatPrice(item.discountValue)}</td>
            <td className="txt-center">{formatPrice(item.totalPrice)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ProductTable;
